class ConfigSingleton{
    static instance;

    constructor(){
        if(ConfigSingleton.instance){
            return ConfigSingleton.instance;
        }

        ConfigSingleton.instance = this;
    }

    async saveConfig(){
        const response = await fetch("/config.json");
        const config = await response.json();

        this.company = config.company;
        this.environment = config.environment;
        this.backendApi = config.backendApi;
        this.enodeAPI = config.enodeAPI;
        this.enodeBackendAPI = config.enodeBackendAPI;
        this.finishCommandEnode = config.finishCommandEnode;
        this.googleMapsApiKey = config.googleMapsApiKey;
        this.fileExplorerAPI = config.fileExplorerAPI;
        this.marketingURL = config.marketingURL;
        this.geolocationAPI = config.geolocationAPI;
        this.pushServerPublicKey = config.pushServerPublicKey;
    }

    loadConfig(){
        return {
            company: this.company,
            environment: this.environment,
            backendApi: this.backendApi,
            enodeAPI: this.enodeAPI,
            enodeBackendAPI: this.enodeBackendAPI,
            finishCommandEnode: this.finishCommandEnode,
            googleMapsApiKey: this.googleMapsApiKey,
            fileExplorerAPI: this.fileExplorerAPI,
            marketingURL: this.marketingURL,
            pushServerPublicKey: this.pushServerPublicKey,
        }
    }
}

const configSingleton = new ConfigSingleton();
export default configSingleton;